import { render, staticRenderFns } from "./StudyViewer.vue?vue&type=template&id=2e8f083c"
import script from "./StudyViewer.vue?vue&type=script&lang=js"
export * from "./StudyViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports